import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface EmployeeProtectedRouteProps {
  children: ReactNode;
}

export function EmployeeProtectedRoute({ children }: EmployeeProtectedRouteProps) {
  const { user, userRole, isLoading } = useAuth();

  // Wait for both auth and role to load before making decisions
  if (isLoading || (user && userRole === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Allow both employees and admins
  if (userRole !== "employee" && userRole !== "admin") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
